<template>
  <div class="validate-login-layout">
    <el-dialog :visible.sync="show" width="4.4rem" :show-close="isShowClose" :before-close="notHideDialog" :modal-append-to-body="false">
      <img loading="lazy" class="v-close cursorPoint" v-lazy="require('../../static/image/pn/close.png')" @click="closeDialog" />
      <div class="v-title">{{ $t("validLoginPage.title") }}</div>
      <div class="v-tip-text">*{{ $t("validLoginPage.desc") }}</div>
      <div class="v-input-box">
        <!-- <span>{{ $t("validLoginPage.realName") }}：</span> -->
        <input type="text" class="logInput" :placeholder="$t('validLoginPage.realNameP')" v-model="realName" />
      </div>
      <div class="submit-btn registerBtn u-flex-all" :class="{ validDis: validIsDis }" @click="validateRealName">{{ $t("validLoginPage.submitBtn") }}</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowClose: false,
      show: false,
      validIsDis: true, //提交验证默认禁用
      realName: "",
      validateRealNameStatus: true
    };
  },
  props: {
    accountNumber: String
  },
  methods: {
    openDialog() {
      this.show = true;
    },
    closeDialog(type) {
      if (type !== 1) {
        this.$parent.validateStatus = -1;
      }
      this.show = false;
    },
    notHideDialog() { },
    async validateRealName() {
      var _this = this;
      var params = {
        name: _this.accountNumber,
        realName: _this.realName
      };
      //账号处理
      if (window.mergeAccount) {
        params.name = this.accountNumber + window.mergeAccount;
      }

      const res = await _this.$http.post(
        _this.$api.validateRealName,
        params,
        true
      );
      if (res.code == 0) {
        _this.validateRealNameStatus = res.data.validateStatus;
        if (_this.validateRealNameStatus) {
          //验证通过
          _this.closeDialog(1);
          _this.$emit("login");
        } else {
          this.$message.error(
            _this.$t("loginPage.logExceptionVerifyFront") +
            res.data.surplusCount +
            _this.$t("loginPage.logExceptionVerifyBack")
          );
        }
      } else {
        var msg =
          _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
          _this.$t("errorCode.webDefault");
        this.$http.errMsg(msg);
      }
    }
  },
  watch: {
    realName() {
      this.validIsDis = false;
    }
  }
};
</script>

<style lang="less">
.validate-login-layout {
  position: relative;
  //   el-dialog
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-dialog {
      border-radius: 0.1rem;
      margin: 0 !important;
      .el-dialog__header {
        padding: 0 !important;
      }
      .el-dialog__body {
        padding: 0.3rem 0.4rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #000;
      }
    }
  }

  .v-close {
    position: absolute;
    top: -0.2rem;
    right: -0.15rem;
    width: 0.4rem;
    height: 0.4rem;
    transition: 1s;
  }
  .v-close:hover {
    transform: rotate(180deg);
  }

  .v-title {
    height: 0.4rem;
    font-size: 0.28rem;
    font-weight: bold;
    color: #2d2b4d;
    margin-bottom: 0.38rem;
  }
  .v-tip-text {
    font-size: 0.13rem;
    font-weight: 500;
    color: #7d7d7d;
    height: 0.2rem;
    margin-bottom: 0.38rem;
  }
  .v-input-box {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    span {
      width: 0.8rem;
      text-align: left;
    }
    input {
      flex: 1;
    }
  }
  .registerBtn {
    width: 100%;
  }
  .validDis {
    opacity: 0.5;
  }
}
</style>
